(() => {
  /**
   * Handle the boost modifier
   */
  class BoostModifier extends PIXI.Container {
    constructor() {
      super();

      this._bubbleScale = 0.6;

      this._boostBubble = null;
      this.tempAnims = [];
      this.tempSprites = [];
      this.shootingSpritePool = [];
      this.shootingSpritePoolLength = 0;

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    delay = (ms) => new Promise((res) => setTimeout(res, ms));

    /**
     * Initialise the class
     */
    initialise() {
      this._boostBubble = resourceManager.get("boostModifier:boostModifierContainer:bubbleBoost");
      this._boostBubble.visible = false;
    }

    /**
     * Grab the devil character spine assets
     */
    _onLayoutComplete() {}

    /**
     * Start the boost modifier
     */
    async start() {
      gameController.centreDevil.fireBallIntro();

      this._boostBubble.visible = true;
      this._boostBubble.scale.set(0);

      const duration = 1;
      const delay = 0.4;

      gsap.to(this._boostBubble, {
        duration,
        delay,
        pixi: { scale: this._bubbleScale },
      });

      await this.delay(1800);

      for (let i = 0; i < gameController.boostModifier.boostedCollectables.length; i++) {
        const reel = helper.convertReelRowToIndex(
          gameController.boostModifier.boostedCollectables[i].coord.reel,
          gameController.boostModifier.boostedCollectables[i].coord.row
        );
        //get new symbolId for gem/coin
        const symID = this.getSymbolID(gameController.boostModifier.boostedCollectables[i]);

        const shootingSprite = this.getShootingSpriteFromPool();
        this.tempSprites.push(shootingSprite);

        if (i === gameController.boostModifier.boostedCollectables.length - 1) {
          this._boostBubble.visible = false;
          gameController.centreDevil.idleLoop();
        }
        await this.shootParticleTween(reel, shootingSprite, symID);
      }

      await new Promise((res) => gsap.delayedCall(1, res));
      //timerManager.addTimeout(1000, () => {
      this._reset();
      gameController.modifierComplete = true;
      //});
    }

    getSymbolID(collectable) {
      if (collectable.type === "Gem") {
        switch (collectable.potName) {
          case "Mini":
            return 8;
          case "Minor":
            return 9;
          case "Major":
            return 10;
          case "Grand":
            return 11;
        }
      }
    }

    async shootParticleTween(reel, sprite, symID) {
      return new Promise((resolve) => {
        const target = (obj) => {
          const globalPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).getGlobalPosition();
          const localPos = obj.parent.toLocal(globalPos);
          return { x: localPos.x, y: localPos.y };
        };
        const spriteTarget = target(sprite);

        const duration = 0.8;

        gsap.delayedCall(0.4, () => {
          resolve();
        });

        soundManager.stop("orbLoop");
        soundManager.play("orbWhoosh");
        gsap.timeline();
        gsap
          .timeline()
          .call(() => {
            sprite.visible = true;
            sprite.x = 0;
            sprite.y = 0;
            sprite.alpha = 1;
            sprite.scale.set(this._bubbleScale);
          })
          .to(sprite, {
            duration,
            ease: "power1.out",
            y: spriteTarget.y,
          })
          .to(
            sprite,
            {
              duration,
              ease: "power1.out",
              x: spriteTarget.x,
              onComplete: () => {
                gameController.convertedReelResults[reel][0] = symID;
                const reelObj = resourceManager.get("slotContainer:reelContainer:reel" + reel);
                reelObj.setReelSymbol(0, symID);

                gsap.to(sprite, {
                  duration: 0.3,
                  alpha: 0,
                  pixi: { scale: this._bubbleScale * 1.3 },
                  onComplete: () => {
                    sprite.visible = false;
                  },
                });

                soundManager.play("orbLand");
              },
            },
            "<"
          );
      });
    }

    /**
     * Fetch a shooting sprite from the pool or create a new one
     */
    getShootingSpriteFromPool = function () {
      let shootingSprite = undefined;

      if (this.shootingSpritePool.length > 0) {
        shootingSprite = this.shootingSpritePool.pop();
      } else {
        this.createShootingSprite();
        shootingSprite = this.shootingSpritePool.pop();
      }
      return shootingSprite;
    };

    /**
     * Create a shooting sprite.
     */
    createShootingSprite() {
      const shootingSprite = resourceManager.createObject(
        "sprite",
        "shootingSprite" + this.shootingSpritePoolLength,
        "boostModifier:boostModifierContainer",
        {
          fileName: "Symbols/Kraken/Multipliers/bubble_boost.png",
          scale: this._bubbleScale,
          anchor: 0.5,
        }
      );
      this.shootingSpritePoolLength++;

      this.shootingSpritePool.push(shootingSprite);
    }

    /**
     * Reset all state
     */
    _reset() {
      this._boostBubble.visible = false;

      this.tempSprites.forEach((sprite) => {
        this.shootingSpritePool.push(sprite);
      });
      while (this.tempSprites.length) {
        this.tempSprites.shift();
      }
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "boostModifier",
    () => new BoostModifier(),
    () => {},
    () => []
  );
})();
